import { DeepPartial, Messages } from '@empathybroker/ebx-gluon';

export const es: DeepPartial<Messages> = {
  custom: {
    orGreater: 'y más',
    clearSearchInput: 'Borrar',
    from: 'Desde',
    otherSellers: 'Otros vendedores (nuevo y 2ª mano) desde {minPrice}',
    availableEditions: 'Formatos disponibles',
    filters: 'Filtros',
    bindingType: {
      1: 'Bolsillo',
      2: 'Tapa dura',
      3: 'Tapa blanda',
      4: 'Otros formatos',
      5: 'eBook'
    }
  },
  facets: {
    clearFilters: 'Borrar todos',
    toggle: {
      default: {
        closeHTML: 'Ver los {numFound} resultados'
      }
    },
    defaultRange: {
      lessHTML: 'Hasta {max}',
      betweenHTML: '{min} - {max}',
      fromHTML: 'A partir de {min}'
    },
    titles: {
      productType_facet: 'Formato',
      hierarchical_category: 'Categorías',
      state_facet: 'Estado',
      lang_facet: 'Idioma',
      editorial_facet: 'Editorial',
      externalScore_facet: 'Valoración',
      price: 'Precio',
      collection_facet: 'Colección'
    }
  },
  partialResult: {
    viewAllHTML: 'Ver todo'
  },
  promotedLabel: 'ir a la categoría de',
  history: {
    clear: 'Limpiar',
    enable: 'OFF',
    disable: 'ON'
  },
  search: {
    inputPlaceholderAlternativesHTML: [
      'Título, ISBN, autor...'
    ]
  },
  sort: {
    titleHTML: 'Ordenar por',
    sortTitles: {
      RELEVANCE: 'Relevancia',
      NAME_ASC: 'Título A-Z',
      NAME_DESC: 'Título Z-A',
      YEAR_ASC: 'Año Publicación',
      YEAR_DESC: 'Año Publicación',
      AUTHOR_ASC: 'Autor ascendente',
      AUTHOR_DESC: 'Autor descendente',
      SCORE: 'Valoración',
      SALES_DESC: 'Nº ventas descendente',
      SALES_ASC: 'Nº ventas ascendente',
      PRICE_ASC: 'Precio ascendente',
      PRICE_DESC: 'Precio descendente'
    }
  },
  results: {
    identifierTitle: 'ISBN:'
  },
  resultsSuggestions: {
    title: 'Los productos más buscados'
  },
  spellcheck: 'La búsqueda no ha dado resultados, quizá quiso decir \'{spellcheck}\''
};
